import { api } from "./axios";

import type {
  AttendanceRosterResponse,
  CheckInRequest,
  CheckInResponse,
} from "@/types/checkin";

export async function getAttendanceRoster(
  churchId: string,
  serviceOccurrenceId: string
): Promise<AttendanceRosterResponse> {
  const response = await api.get(
    `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/roster`
  );

  return response.data;
}

export async function checkInMember(
  churchId: string,
  serviceOccurrenceId: string,
  data: CheckInRequest
): Promise<CheckInResponse> {
  const response = await api.post(
    `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/check-in`,
    {
      ...data,
      status: "PRESENT",
    }
  );

  return response.data;
}

export async function removeMemberCheckIn(
  churchId: string,
  serviceOccurrenceId: string,
  memberId: string
): Promise<void> {
  await api.delete(
    `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/check-in/${memberId}`
  );
}

export type OccurrenceAttendancePage = {
  items: (import("@/types/attendance").AttendanceRecord & { member_name: string })[];
  page: number;
  page_size: number;
  total: number;
  present_total: number;
};

export async function getOccurrenceAttendance(churchId: string, occurrenceId: string, page = 1, search = "") {
  const response = await api.get<OccurrenceAttendancePage>(
    `/api/churches/${churchId}/service-occurrences/${occurrenceId}/attendance-records`,
    { params: { page, page_size: 25, search } }
  );
  return response.data;
}
